"use client";

import React from "react";
import { Plus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const principles = [{
  title: "Адвокатская тайна и конфиденциальность",
  content: "Безусловная защита вашей информации и интересов. Мы гарантируем полную конфиденциальность всех доверенных нам сведений, опираясь на закон об адвокатской деятельности и профессиональную этику."
}, {
  title: "Комплексный анализ правовых рисков",
  content: "Тщательная экспертиза документов и обстоятельств дела на начальном этапе. Мы выявляем скрытые угрозы и прогнозируем возможные сценарии развития событий для принятия взвешенных решений."
}, {
  title: "Приоритет досудебного урегулирования",
  content: "Стремление к разрешению споров путем медиации и переговоров. Наш опыт позволяет достигать выгодных соглашений без длительных судебных тяжб, экономя время и ресурсы клиента."
}, {
  title: "Профессиональная компетентность",
  content: "Более 11 лет успешной практики в гражданском праве и арбитраже. Сочетание юридического и психологического образования дает уникальное преимущество в сложных судебных процессах."
}, {
  title: "Прозрачность и честная оценка",
  content: "Объективное информирование о перспективах дела. Мы не даем пустых обещаний, а предлагаем реалистичные стратегии защиты, основанные на актуальной судебной практике и прецедентах."
}];
export default function PrinciplesOfDefense() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="153584" id="принципы-работы" className="bg-background text-foreground">
      <div className="bg-primary text-primary-foreground py-24 md:py-32">
        <div ref={ref} className={`mx-auto max-w-5xl px-6 transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
          <h2 className="mb-16 font-serif text-4xl font-bold tracking-widest md:mb-24 md:text-6xl">
            Принципы работы
          </h2>

          <Accordion type="single" collapsible className="w-full border-t border-primary-foreground/20">
            {principles.map((item, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-primary-foreground/20">
                <AccordionTrigger className="group py-6 font-serif text-xl font-normal tracking-wide hover:no-underline md:py-8 md:text-3xl [&>svg:last-child]:hidden">
                  <span className="flex-1 text-left">{item.title}</span>
                  <Plus className="size-6 shrink-0 transition-transform duration-300 group-data-[state=open]:rotate-45 md:size-8 text-primary-foreground/60" />
                </AccordionTrigger>
                <AccordionContent className="max-w-3xl pb-8 font-sans text-base leading-relaxed text-primary-foreground/80 md:pb-12 md:text-lg">
                  {item.content}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}